import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process } from '@progress/kendo-data-query';
import { LoanDetailsListOfLoansService } from 'app/modules/shared/loan-details-modal/loan-details-list-of-loans.service';
import {
    SiteSearchService,
    SiteSearchDataModel,
} from 'app/modules/shared/services/site-search.service';
import { Router } from '@angular/router';
import { State } from '@progress/kendo-data-query';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationAlertDialogComponent } from 'app/modules/settings/components/confirmation-alert-dialog/confirmation-alert-dialog.component';
import { DeleteLoanService } from 'app/modules/shared/services/delete-loan.service';
import { ToastService } from 'app/modules/shared/services/toast.service';

@Component({
    selector: 'delete-loan',
    templateUrl: './delete-loan.component.html',
    styleUrls: ['./delete-loan.component.scss'],
})
export class DeleteLoanComponent implements OnInit {
    results: SiteSearchDataModel[] = [];
    pendingLoans: SiteSearchDataModel[] = [];
    gridView: GridDataResult;
    sortable = {
        mode: 'single',
        allowUnsort: true,
    };
    type: 'numeric' | 'input' = 'input';
    allResults: boolean = false;
    groupable = true;
    scrollable = 'scrollable';
    pageable = {
        refresh: true,
        info: true,
        type: this.type,
        previousNext: true,
        pageSizes: [5, 10, 20],
    };
    loading: boolean = false;
    searchTerm: string = '';
    state: State = {
        skip: 0,
        take: 10,
        sort: [
            {
                field: 'name',
                dir: 'asc',
            },
        ],
    };
    keys: string[] = ['identifier', 'name'];
    total: number = 0;
    constructor(
        private listOfLoansService: LoanDetailsListOfLoansService,
        private router: Router,
        private siteSearchService: SiteSearchService,
        public Matdialog: MatDialog,
        private deleteLoanService: DeleteLoanService,
        private toastService: ToastService
    ) {}

    ngOnInit() {}

    getPendingLoans() {
        this.deleteLoanService.getPendingLoans().subscribe((pendingLoans) => {
            this.pendingLoans = pendingLoans ?? [];
            this.loadData();
        });
    }

    updateGrid() {
        this.loading = true;
        this.siteSearchService
            .getSiteSearchResults(
                this.searchTerm,
                'L', //Only looking at loans
                this.state.skip,
                this.state.take,
                this.getSortField(),
                this.allResults
            )
            .subscribe(
                (data) => {
                    this.loading = false;
                    this.results = data;
                    this.getPendingLoans();
                },
                (error) => {
                    this.loading = false;
                    throw new Error(error);
                }
            );
    }

    loadData() {
        let mergedResults = this.mergeArrays(this.results, this.pendingLoans);
        this.gridView = {
            data: orderBy(mergedResults, this.state.sort),
            total: this.results[0]?.totalRows ?? 0,
        };
        this.loading = false;
    }

    deleteHandler(loanNumber) {
        const dialogRef = this.Matdialog.open(ConfirmationAlertDialogComponent, {
            data: {
                title: 'Delete Loan ' + loanNumber + '?',
                message: `You're about to permanently delete this loan from nCino Mortgage Analytics. It is not recoverable without the extensive
                     coordinated efforts of both your LOS administrator and nCino. Deletes are processed hourly.
                     If you're not sure, please click Cancel.`,
                acceptTerm: 'DELETE',
                rejectTerm: 'CANCEL',
            },
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'accept') {
                this.deleteLoanService.deleteLoan(loanNumber).subscribe(
                    () => {
                        this.toastService.success('Loan in queue for deletion.');
                        this.updateGrid();
                    },
                    () => {
                        this.toastService.warning('Error deleting loan.');
                    }
                );
            }
        });
    }

    getSortField(): string {
        if (this.state.sort.length && this.gridView?.data?.length) {
            let sortCol = this.keys.indexOf(this.state.sort[0].field) + 1; //sql index starts at 1;
            if (sortCol > 0) {
                let sortDir = this.state.sort[0].dir ? this.state.sort[0].dir.charAt(0) : 'a';
                return sortCol + sortDir;
            }
        }
        return '2a';
    }

    mergeArrays(arr1: SiteSearchDataModel[], arr2: SiteSearchDataModel[]) {
        let res: SiteSearchDataModel[] = arr1.map((obj) => {
            const index = arr2.findIndex((el) => el.loanNumber == obj.identifier);
            obj.requestedByEmail = index !== -1 ? arr2[index].requestedByEmail : '';
            return Object.assign({}, obj);
        });
        return res;
    }

    dataStateChange(state: DataStateChangeEvent): void {
        this.state = state;
        this.updateGrid();
    }

    cellClickHandler(record) {
        this.openLoanModal(record.identifier);
    }

    openLoanModal(identifier: string) {
        this.router.navigate([{ outlets: { modal: 'loanDetails' + '/' + identifier } }]);
    }

    openPage(route: string, id: string) {
        this.router.navigate([`${route}${id}`]);
    }

    searchRows(event) {
        this.searchTerm = event;
        this.updateGrid();
    }

    ngOnDestroy() {}
}
